const aurora = {
  "durations": {
    "quick": "200ms",
    "normal": "300ms",
    "slow": "400ms"},
  "easings": {
    "easeOut": "cubic-bezier(0.215, 0.61, 0.355, 1)",
    "linear": "cubic-bezier(0, 0, 1, 1)"
  },
  "spacing": {
    "3": "0.75rem"}};
const {
  durations,
  easings,
  spacing} = aurora;

export { durations as d, easings as e, spacing as s };
